import styled from "styled-components"
import { device } from "../../utils/breakpoints.js"
import { MainColumn } from "components/MainColumn"
import Arrow from "images/icons/arrow-right.svg"

export const ContentWrapper = styled.div`

margin-bottom: 30px;

@media ${device.desktop} {
  margin-bottom: 60px;
}

/* overflow:hidden; */
/* padding-bottom: 80px; */
  h1,
  h2,
  h3,
  h5,
  h6 {
    margin-top: 20px;
    margin-bottom: 13px;
    font-size: 24px;

  
    @media ${device.desktop} {
      margin-top: 43px;
      margin-bottom: 15px;
      font-size: 24px;

      ${props =>
        props.blog &&
        `
        font-size:22px;
        margin-bottom:20px;
    `};
    }
  }

  > h1:first-of-type, >h2:first-of-type {
    ${props =>
      props.blog &&
      `
      line-height: 130%;
      font-size: 26px;
      margin-bottom: 15px;
      margin-top:0;
      padding:0;
      border-top:none;
      color:#10523D;
      @media ${device.desktop} {
      font-size: 36px;
      margin-bottom: 20px;
      margin-top:0;
      padding:0;
      }

    `};
  }

  > h4 {
    font-size: 16px;
    margin-bottom:8px;
    color:#043828;
    font-weight: 500;
    @media ${device.desktop} {
      font-size: 18px;
      margin-bottom: 13px;
      width: 75%;
    }
  }

  > p {
    font-size: 16px;
    margin-bottom: 15px;
    @media ${device.desktop} {
      font-size: 18px;
      margin-bottom: 16px;
      width: 75%;
    }

    &:first-of-type {
      color: #043828;
      font-weight: 500;
      font-size: 24px;
      margin-bottom: 15px;

      @media ${device.desktop} {
        font-size: 30px;
        margin-bottom: 25px;
        width: 66.66667%;
      }

      ${props =>
        props.blog &&
        `
        position:relative;
        color: #3C3C3C;
        font-weight: 300;


        @media ${device.desktop} {
          font-size: 18px;
          margin-bottom: 16px;
  
        }

        
        

      `};
    }

    a {
      display: inline-block;
      position: relative;
      color: ${props => props.theme.linkColor};
      font-weight: 600;
      ::after {
        content: "";
        position: absolute;
        bottom: 1px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: ${props => props.theme.linkColor};
        opacity: 0;
        transition: 90ms;
      }

      :hover {
        ::after {
          opacity: 1;
        }
      }
    }
  }

  blockquote > p {
    color: #043828;
    font-weight: 400;
    font-size: 24px;
    margin-bottom: 50px;

    @media ${device.desktop} {
      font-size: 30px;
      margin-bottom: 70px;
      width: 66.66667%;
    }
  }

 
  .wp-block-image {
    margin-top: 30px;
    margin-bottom: 30px;
    position: relative;
    height: 116px;
    width: 181px;
   
    @media ${device.desktop} {
      margin-bottom: 30px;
      margin-top: 30px;
      height: 131px;
      width: 270px;
    }

    img {
      width: 100%;
      display: block;
      position: absolute;
      border: none;
      object-fit:cover;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #d8d8d8;
    }


        ${props =>
          props.blog &&
          `
    
    width: 100%;
    padding-top: 64.2%;
    margin-top: 40px;
    margin-bottom: 40px;
    
    @media ${device.desktop} {
      width:auto;
      height:auto;
      padding-top:0;
    }
    `};

  }

  .alignwide,
  .alignfull {
    width: 100%;
    padding-top: 64.2%;
    margin-top: 15px;
    margin-bottom: 15px;
    @media ${device.desktop} {
      padding-top: 47.9%;
      margin-bottom: 65px;
      margin-top: 25px;
      width: 75%;
    }
  }

  .alignright {
    width: 100%;
    padding-top: 64.2%;
    margin-top: 40px;
    margin-bottom: 40px;
    @media ${device.desktop} {
    position:relative;
      padding-top: 0;
      float: right;
      margin-top: 0;
      margin-left: 40px;
      margin-right: 143px;
      width: 502px;
      height: 332px;
    }

    @media ${device.large} {
      margin-right: 173px;
      margin-left: 60px;
    }
  }

  blockquote + * {
    margin-top:0;
  }


  blockquote {
    border-top: 1px solid #d5d5d5;
    padding-top: 75px;
    padding-bottom: 75px;

    ${props =>
      props.blog &&
      `
            padding-top: 35px;
      padding-bottom: 45px;
      `};
    @media ${device.desktop} {
      padding-top: 95px;
      padding-bottom: 105px;

      ${props =>
        props.blog &&
        `
            padding-top: 65px;
      padding-bottom: 65px;
      `};
    }

    p {
      margin-bottom: 0px !important;
      position: relative;

      @media ${device.desktop} {
        margin-bottom: 0px !important;
      }
      :before {
        content: open-quote;

        @media ${device.desktop} {
          top: 0;
          position: absolute;
          left: -14px;
        }
      }
      :after {
        content: close-quote;
      }
    }

    cite {
      font-style: normal;
      margin-top: 25px !important;
      color: #10523d;
      font-weight: 400;
      display: flex;
      flex-direction: column;
      font-size: 16px;
      @media ${device.desktop} {
        flex-direction: row;
        font-size: 18px;
        margin-top: 20px !important;
      }

      strong {
        font-weight: 500;
        margin-right:5px;
      }

      /* span {
        font-weight: 400;

        @media ${device.desktop} {
          margin-left: 24px;
          position: relative;

          :before {
            content: "";
            position: absolute;
            top: 50%;
            left: -6px;
            transform: translate3d(-100%, -50%, 0);
            height: 1px;
            width: 10px;
            background: #10523d;
          }
        }
      } */
    }
  }
  .wp-block-button {
    padding-top: 10px;
    .wp-block-button__link {
      height: 50px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      align-self: flex-start;
      color: white;
      background: ${props => props.theme.green};
      padding: 0 27px;
      border-radius: 24.75px;
      font-weight: 500;
      transition: 180ms;
      margin-bottom: 17px;
      position: relative;
      padding-right: 50px;
      @media ${device.desktop} {
        font-size: 18px;
        padding: 0 30px;
        height: 55px;
        border-radius: 27.5px;
        margin-bottom: 20px;
        padding-right: 60px;
      }

      :hover {
        opacity: 0.75;
      }

      :before {
        content: "";
        background-image: url(${Arrow});
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 25px;
        width: 17px;
        height: 16px;

        @media ${device.desktop} {
          width: 18px;
          height: 17px;
          right: 28px;
        }
      }
    }
  }

  ul{
    font-size: 16px;
    margin-bottom: 35px;
    width: 75%;
    margin:0 0 20px 19px;

    li {
      margin-bottom: 10px;
    }
    
    @media ${device.desktop} {
      font-size: 18px;
      margin-bottom: 40px;


  }
`
